import {
  ClassEnrollmentsApi,
  type DropEnrollmentRequest,
} from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";

/** Parent/member requests withdrawal; no body - BE records request server-side. */
export async function scheduleEnrollmentDrop(
  accessToken: string,
  enrollmentId: number,
): Promise<void> {
  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
  await service.apiClassEnrollmentsIdScheduledDropPut({ id: enrollmentId });
}

/** Admin withdraws on a chosen date (today or future). */
export async function dropEnrollmentById(
  accessToken: string,
  enrollmentId: number,
  dropDateYmd: string,
  approveScheduledDrop = false,
): Promise<void> {
  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
  const body: DropEnrollmentRequest = {
    dropDate: dropDateYmd,
    ...(approveScheduledDrop ? { approveScheduledDrop: true } : {}),
  };
  await service.apiClassEnrollmentsIdDropPut({
    id: enrollmentId,
    dropEnrollmentRequest: body,
  });
}

/** Reject a waitlist / pending enrollment request (`Pending` / `Awaiting`). */
export async function rejectEnrollmentById(
  accessToken: string,
  enrollmentId: number,
): Promise<void> {
  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
  await service.apiClassEnrollmentsIdRejectPut({ id: enrollmentId });
}

/**
 * Cancel a scheduled drop / withdrawal request - PUT /api/class-enrollments/{id}/cancel-scheduled-drop.
 * BE returns the enrollment to `Enrolled`; the student stays in the class.
 */
export async function cancelScheduledDropById(
  accessToken: string,
  enrollmentId: number,
): Promise<void> {
  const service = createAuthenticatedApi(ClassEnrollmentsApi, accessToken);
  await service.apiClassEnrollmentsIdCancelScheduledDropPut({ id: enrollmentId });
}
